<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[ { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },  skin === 'light'|| skin === 'bordered' ? 'menu-light' : 'menu-dark' ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot name="header" :toggleVerticalMenuActive="toggleVerticalMenuActive" :toggleCollapsed="toggleCollapsed" :collapseTogglerIcon="collapseTogglerIcon" >
        <ul class="nav navbar-nav flex-row align-items-center w-100 mt-2 justify-content-between" style="padding: auto  10px;">

          <!-- Logo & Text -->
          <div class="d-flex align-items-end">
            <li class="nav-item" v-if="isVerticalMenuCollapsed && !isMouseHovered">
              <BLink class="navbar-brand mx-auto m-0" to="/">
                <span style="padding-right: 8px;" :class="!(!isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered)) ? 'pr-2' : ''">
                  <BImg :src="appLogoImage" alt="logo" width="45" />
                </span>
              </BLink>
            </li>
            <li class="nav-item mx-auto" style="padding-bottom: 5px;" v-if="!isVerticalMenuCollapsed || isMouseHovered">
              <BLink class="navbar-brand m-0" to="/">
                <BImg v-if="localStorage.getItem('vspanel-skin') == 'light' " :src="appLogoLetraLight" alt="Logo" width="125" />
                <BImg v-else :src="appLogoLetraDark" alt="Logo" width="150" />
              </BLink>
            </li>

          </div>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <BLink class="navbar-brand nav-link mx-auto my-0">
              <FeatherIcon icon="XIcon" size="20" class="d-block d-xl-none" @click="toggleVerticalMenuActive" />
              <FeatherIcon :icon="collapseTogglerIconFeather" size="20" class="d-none d-xl-block collapse-toggle-icon" @click="toggleCollapsed" />
            </BLink>
          </li>

        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{'d-block': shallShadowBottom}" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="main-menu-content scroll-area" tagname="ul" @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }" >
      <vertical-nav-menu-items :items="navMenuItems" class="navigation navigation-main" />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const { isMouseHovered, isVerticalMenuCollapsed, collapseTogglerIcon, toggleCollapsed, updateMouseHovered } = useVerticalNavMenu(props)
    const { appName, appLogoImage, appLogoLetraLight, appLogoLetraDark } = $themeConfig.app
    const { skin } = useAppConfig()
    const shallShadowBottom = ref(false)
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    provide('isMouseHovered', isMouseHovered)

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,
      shallShadowBottom,
      skin,
      appName,
      appLogoImage,
      appLogoLetraLight,
      appLogoLetraDark,
      localStorage
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
